import { Outlet , Navigate } from "react-router-dom";
export default function ProtectedRoutes(){
    const isAuthenticated = localStorage.length > 0;

    console.log("Is Authenticated:", isAuthenticated);
  
    return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
}